import React, { FunctionComponent } from 'react';
import styled from "styled-components";
import {Box, ButtonBase} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {getThemeColor, getThemeFadedColor} from "@src/Shared/theme";

export const ActionButtonRoot = styled(ButtonBase)`
    padding: 8px !important;
    font-size: 1em;
    margin-top: 16px !important;
    justify-content: left !important;
    text-align: left;
    border-radius: 8px !important;
    :hover {
        background-color: rgb(247, 247, 247);
    }
`;

export const IconCircle = styled.div`
    border-radius: 50%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-right: 16px;
    color: ${(props: { color: any; }) => getThemeColor(props.color)};
    background-color: ${(props: { color: any; }) => getThemeFadedColor(props.color)};
    opacity: 0.8;
    svg {
        font-size: 1rem;
    }
`;

export const ButtonLabel = styled.div`
    color: ${(props: { color: any; }) => getThemeColor(props.color)};
`;

interface IActionButtonProps {
    color?: "red" | "blue" | "green" | "maranics" | "orange" | "violet";
    labelColor?: "red" | "blue" | "green" | "maranics" | "orange" | "violet";
    icon: any;
    label: string;
    subLabel?: string;
    href?: string;
    onClick?: (e: any) => void;
    disabled?: boolean;
}

const ActionButton: FunctionComponent<IActionButtonProps> = (props: IActionButtonProps) => {
    let history = useHistory();
    
    function onButtonRootClick(ev: any) {
        if (props.href) {
            history.push(props.href);
        } else if (props.onClick) {
            props.onClick(ev);
        }
    }
    
    return (
        <ActionButtonRoot onClick={(e: any) => onButtonRootClick(e)} disabled={props.disabled}>
            <IconCircle color={props.disabled ? "gray" : props.color}>
                {props.icon}
            </IconCircle>
            { props.subLabel ? (
                <div>
                    <ButtonLabel color={props.disabled ? "gray" : props.labelColor}>
                        {props.label}
                    </ButtonLabel>
                    <ButtonLabel color={"gray"} style={{ marginTop: 8 }}>
                        {props.subLabel}
                    </ButtonLabel>
                </div>
            ) : (
                <ButtonLabel color={props.disabled ? "gray" : props.labelColor}>
                    {props.label}
                </ButtonLabel>
            )}
        </ActionButtonRoot>
    );
}

export default ActionButton;